import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';

export function NotFoundRoute() {
  const { t } = useI18n();
  return (
    <div className="centre-state">
      <h1 className="page__title">{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link className="button" to="/">
        {t('notFound.home')}
      </Link>
    </div>
  );
}
